import { render } from "./LaporanKpiGabunganKpiDetail.vue?vue&type=template&id=485d5383&scoped=true"
import script from "./LaporanKpiGabunganKpiDetail.vue?vue&type=script&lang=js"
export * from "./LaporanKpiGabunganKpiDetail.vue?vue&type=script&lang=js"

import "./LaporanKpiGabunganKpiDetail.vue?vue&type=style&index=0&id=485d5383&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485d5383"]])

export default __exports__